import { Routes, Route, Navigate } from "react-router-dom";
import { Signup } from "pages/Authentication";

const PublicRoutes = () => (
  <Routes>
    <Route path="/signup/invite" element={<Signup />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default PublicRoutes;
